import { render, staticRenderFns } from "./FotoBlock2.vue?vue&type=template&id=eeb0a15a&scoped=true&"
import script from "./FotoBlock2.vue?vue&type=script&lang=js&"
export * from "./FotoBlock2.vue?vue&type=script&lang=js&"
import style0 from "./FotoBlock2.vue?vue&type=style&index=0&id=eeb0a15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb0a15a",
  null
  
)

export default component.exports